var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "monitor-history-datatable",
      attrs: { id: "monitor-history-datatable" }
    },
    [
      _vm.show_copyright_logo
        ? _c("div", { staticClass: "capture" }, [
            _c(
              "div",
              { staticClass: "capture__text-container" },
              [
                _c("v-progress-circular", {
                  staticClass: "capture__progress",
                  attrs: {
                    indeterminate: "",
                    size: "18",
                    width: "2",
                    color: "black"
                  }
                }),
                _vm._v(
                  "\n                 " +
                    _vm._s(_vm.$t("__datatable.capture_text")) +
                    "\n        "
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.is_loading
        ? _c(
            "div",
            { attrs: { id: "history_loading" } },
            [
              _c(
                "v-alert",
                {
                  staticClass: "info color_white",
                  attrs: { value: true, color: "#3366a9" }
                },
                [
                  _c("v-progress-circular", {
                    staticClass: "color_white",
                    attrs: { indeterminate: "", color: "black" }
                  }),
                  _vm._v(
                    "\n                 " +
                      _vm._s(_vm.$t("__datatable.loading_text")) +
                      "\n        "
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "table_fixed_title" }, [_vm._v("項次")]),
      _vm._v(" "),
      !_vm.is_loading
        ? _c(
            "div",
            { staticClass: "history_table", attrs: { id: "history_table" } },
            [
              _c(
                "div",
                {
                  staticClass: "history_table_left",
                  attrs: { id: "history_table_left" }
                },
                [
                  _c("div", { staticClass: "col_title" }, [
                    _vm._v("\n                項 次\n            ")
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.history_item_list, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: "item" + index,
                        staticClass: "col_data",
                        style:
                          _vm.search && item.is_search
                            ? "background-color: #5d7a4b;"
                            : _vm.get_item_bg_color(item.most_serious_light),
                        attrs: { id: "col_data_" + item.item_number },
                        on: {
                          mouseover: function($event) {
                            return _vm.set_item_tooltip_position(
                              $event,
                              "col_data_" + item.item_number
                            )
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(item.item_number) +
                            "\n\n                "
                        ),
                        _c(
                          "div",
                          { staticClass: "item_tooltip" },
                          _vm._l(_vm.search_column, function(
                            column,
                            column_index
                          ) {
                            return _c(
                              "div",
                              { key: "tooltip" + column_index },
                              [
                                _vm._v(
                                  _vm._s(column) +
                                    " : " +
                                    _vm._s(item.item_description[column])
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ]
                    )
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "history_table_right",
                  attrs: { id: "history_table_right" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "history_table_right_1",
                      attrs: { id: "history_table_right_1" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "history_table_right_2",
                          attrs: { id: "history_table_right_2" }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "date_row" },
                            _vm._l(_vm.history_date_list, function(
                              date,
                              date_index
                            ) {
                              return _c(
                                "div",
                                {
                                  key: "date-" + date_index,
                                  style:
                                    date_index === 0 ? "border-left: none;" : ""
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(date) +
                                      "\n                        "
                                  )
                                ]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "hour_row" },
                            _vm._l(_vm.history_hour_list, function(
                              i,
                              hour_index
                            ) {
                              return _c(
                                "div",
                                {
                                  key: "num" + hour_index,
                                  style:
                                    hour_index === 0 ? "border-left: none;" : ""
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(i) +
                                      "\n                        "
                                  )
                                ]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "data_row" },
                            _vm._l(_vm.history_item_list, function(
                              item,
                              data_index_1
                            ) {
                              return _c(
                                "div",
                                {
                                  key: "data-1" + data_index_1,
                                  staticClass: "data_row_1"
                                },
                                _vm._l(_vm.history_date_list, function(
                                  date,
                                  data_index_2
                                ) {
                                  return _c(
                                    "div",
                                    {
                                      key: "data-2" + data_index_2,
                                      staticClass: "data_row_2"
                                    },
                                    _vm._l(_vm.hour_list, function(
                                      hour,
                                      data_index_3
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key: "data-3" + data_index_3,
                                          staticClass: "data_row_3",
                                          style:
                                            data_index_1 == 0 &&
                                            data_index_2 == 0 &&
                                            data_index_3 == 0
                                              ? "border-left: none;"
                                              : ""
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "data_cell",
                                              attrs: {
                                                id:
                                                  "data_cell_" +
                                                  item.item_number +
                                                  "_" +
                                                  date +
                                                  "_" +
                                                  hour
                                              },
                                              on: {
                                                mouseover: function($event) {
                                                  return _vm.set_data_tooltip_position(
                                                    $event,
                                                    "data_tooltip_" +
                                                      item.item_number +
                                                      "_" +
                                                      date +
                                                      "_" +
                                                      hour
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm.history_data_obj[
                                                item.item_number
                                              ][date][hour].light
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        width: "100%",
                                                        height: "100%"
                                                      },
                                                      style:
                                                        _vm.search &&
                                                        _vm.history_data_obj[
                                                          item.item_number
                                                        ][date][hour].is_search
                                                          ? "background-color: #5d7a4b;"
                                                          : ""
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "data_icon"
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              class:
                                                                _vm
                                                                  .history_data_obj[
                                                                  item
                                                                    .item_number
                                                                ][date][hour]
                                                                  .icon_class
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                    " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .history_data_obj[
                                                                      item
                                                                        .item_number
                                                                    ][date][
                                                                      hour
                                                                    ].icon
                                                                  ) +
                                                                  "\n                                                "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.history_data_obj[
                                            item.item_number
                                          ][date][hour].alert.length > 0
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "data_tooltip",
                                                  attrs: {
                                                    id:
                                                      "data_tooltip_" +
                                                      item.item_number +
                                                      "_" +
                                                      date +
                                                      "_" +
                                                      hour
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                        警示原因 "
                                                  ),
                                                  _c("br"),
                                                  _vm._v(" "),
                                                  _vm._l(
                                                    _vm.history_data_obj[
                                                      item.item_number
                                                    ][date][hour].alert,
                                                    function(
                                                      alert,
                                                      data_index_4
                                                    ) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key:
                                                            "data-4" +
                                                            data_index_4,
                                                          staticClass:
                                                            "alert_text"
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                alert.date_time.substring(
                                                                  0,
                                                                  4
                                                                ) +
                                                                  "-" +
                                                                  alert.date_time.substring(
                                                                    4,
                                                                    6
                                                                  ) +
                                                                  "-" +
                                                                  alert.date_time.substring(
                                                                    6,
                                                                    8
                                                                  ) +
                                                                  " " +
                                                                  alert.date_time.substring(
                                                                    8,
                                                                    10
                                                                  ) +
                                                                  ":" +
                                                                  alert.date_time.substring(
                                                                    10,
                                                                    12
                                                                  ) +
                                                                  " "
                                                              )
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("span", {
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                alert.alert_text
                                                              )
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    }
                                                  )
                                                ],
                                                2
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                }),
                                0
                              )
                            }),
                            0
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table__btn-container" },
        [
          _vm.show_download_pdf_btn && !_vm.is_loading
            ? _c(
                "v-btn",
                {
                  staticClass: "table__btn",
                  attrs: { fab: "", "x-small": "" },
                  on: { click: _vm.download_as_pdf }
                },
                [
                  _c("v-icon", { attrs: { color: "#2366f8" } }, [
                    _vm._v("\n                icon-file-download\n            ")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "table__btn-text" }, [
                    _vm._v("下載表格")
                  ])
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.show_download_table,
              expression: "show_download_table"
            }
          ],
          staticStyle: { "margin-top": "2000px" }
        },
        [
          _c(
            "div",
            {
              staticClass: "history_table_for_download",
              attrs: { id: "history_table_for_download" }
            },
            _vm._l(_vm.history_date_list, function(date, date_index) {
              return _c(
                "div",
                {
                  key: "date_for_download" + date_index,
                  class: "history_table_for_download_" + date_index
                },
                [
                  _c(
                    "div",
                    { staticClass: "history_table_left" },
                    [
                      _c("div", { staticClass: "col_title" }, [
                        _vm._v(
                          "\n                        項 次\n                    "
                        )
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.history_item_list, function(item, index) {
                        return _c(
                          "div",
                          { key: "item" + index, staticClass: "col_data" },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(item.item_number) +
                                "\n                    "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "history_table_right" }, [
                    _c("div", { staticClass: "history_table_right_1" }, [
                      _c("div", { staticClass: "history_table_right_2" }, [
                        _c("div", { staticClass: "date_row" }, [
                          _c(
                            "div",
                            { staticStyle: { "border-left": "none" } },
                            [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(date) +
                                  "\n                                "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "hour_row" },
                          _vm._l(_vm.hour_list, function(i, hour_index) {
                            return _c(
                              "div",
                              {
                                key: "num" + hour_index,
                                style:
                                  hour_index === 0 ? "border-left: none;" : ""
                              },
                              [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(i) +
                                    "\n                                "
                                )
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "data_row" },
                          _vm._l(_vm.history_item_list, function(
                            item,
                            data_index_1
                          ) {
                            return _c(
                              "div",
                              {
                                key: "data-1" + data_index_1,
                                staticClass: "data_row_1"
                              },
                              _vm._l(_vm.hour_list, function(
                                hour,
                                data_index_3
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: "data-3" + data_index_3,
                                    staticClass: "data_row_3",
                                    style:
                                      data_index_1 == 0 && data_index_3 == 0
                                        ? "border-left: none;"
                                        : ""
                                  },
                                  [
                                    _vm.history_data_obj[item.item_number][
                                      date
                                    ][hour].light
                                      ? _c(
                                          "div",
                                          { staticClass: "data_cell" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  width: "100%",
                                                  height: "100%"
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "data_icon" },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        class:
                                                          _vm.history_data_obj[
                                                            item.item_number
                                                          ][date][hour]
                                                            .icon_class
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                                        " +
                                                            _vm._s(
                                                              _vm
                                                                .history_data_obj[
                                                                item.item_number
                                                              ][date][hour].icon
                                                            ) +
                                                            "\n                                                    "
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              }),
                              0
                            )
                          }),
                          0
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.show_copyright_logo,
                          expression: "show_copyright_logo"
                        }
                      ],
                      staticClass: "copyright"
                    },
                    [
                      _c("img", {
                        staticClass: "copyright__img",
                        attrs: {
                          src:
                            "/static/images/capture/blue_cwa_logo_string_eng.png"
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "page-break" })
                ]
              )
            }),
            0
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }